var usePageDots = Shopify.theme_settings.page_dots_enabled,
    imageFunctions = {
        zoom: function() {
            var e = $(event.target),
                t = e.data("zoom-src");
            t && e.wrap('<span class="zoom-container"></span>').css("display", "block").parent().zoom({
                url: t,
                touch: !1,
                magnify: 1
            })
        },
        linkGalleryAndCarousel: function(e, t) {
            t.find(".gallery-cell:nth-child(1)").addClass("is-nav-selected"), t.on("click", ".gallery-cell", function() {
                var a = $(this).index();
                t.find(".is-nav-selected").removeClass("is-nav-selected"), $(this).addClass("is-nav-selected"), e.flickity("select", a)
            }), e.on("select.flickity", function() {
                var e = $(this).data("flickity");
                e && (t.find(".is-nav-selected").removeClass("is-nav-selected"), t.find(".gallery-cell:nth-child(" + (e.selectedIndex + 1) + ")").addClass("is-nav-selected"))
            })
        },
        fullWidth: function(e, t) {
            $(e).each(function() {
                var e = $(this),
                    a = e.attr("alt"),
                    i = e.attr("src");
                if (a.indexOf("[") >= 0) {
                    e.remove();
                    var o = a.match(/\[(.*?)\]/gi);
                    a = a.replace(/\[(.*?)\]/gi, "");
                    var s = $.map(o, function(e, t) {
                            return e = e.replace(/[\[\]']+/g, "")
                        }),
                        r = ['<div class="position-' + (s.length ? s : "center") + ' caption js-caption">', '<div class="caption-content caption-background-false align-' + (s.length ? s : "center") + '">', '<p class="headline">' + a + "</p>", "</div>", "</div>"].join("");
                    e.attr({
                        alt: a,
                        class: "lazyload appear",
                        src: i,
                        dataSizes: "auto"
                    });
                    var n = '<div class="banner">' + e.prop("outerHTML") + r + "</div>";
                    $(t).append(n)
                }
            })
        },
        showSecondaryImage: function() {
            Shopify.media_queries.large.matches && ($(".has-secondary-media-swap").off().on("mouseenter", function() {
                "dropdown" == Shopify.theme_settings.product_form_style && $(this).find(".product_gallery").toggleClass("secondary-media-hidden"), $(this).find(".image-element__wrap img").toggleClass("secondary-media-hidden"), $(this).find("[data-html5-video]").toggleClass("secondary-media-hidden"), $(this).find(".external-video__container").toggleClass("secondary-media-hidden"), videoFeature.enableVideoOnHover($(this))
            }), $(".has-secondary-media-swap").on("mouseleave", function() {
                "dropdown" == Shopify.theme_settings.product_form_style && $(this).find(".product_gallery").toggleClass("secondary-media-hidden"), $(this).find(".image-element__wrap img").toggleClass("secondary-media-hidden"), $(this).find("[data-html5-video]").toggleClass("secondary-media-hidden"), $(this).find(".external-video__container").toggleClass("secondary-media-hidden"), videoFeature.enableVideoOnHover($(this))
            }))
        },
        flickityIosFix: function() {
            var e, t = !1;
            document.body.addEventListener("touchstart", function(a) {
                a.target.closest(".flickity-slider") ? (t = !0, e = {
                    x: a.touches[0].pageX,
                    y: a.touches[0].pageY
                }) : t = !1
            }), document.body.addEventListener("touchmove", function(a) {
                if (t && a.cancelable) {
                    var i = {
                        x: a.touches[0].pageX - e.x,
                        y: a.touches[0].pageY - e.y
                    };
                    Math.abs(i.x) > 7 && a.preventDefault()
                }
            }, {
                passive: !1
            })
        }
    },
    recentlyViewed = {
        init: function() {
            var e, t, a, i, o;
            if ($(".js-product_section[data-rv-handle]").length ? (e = $(".js-product_section").data("rv-handle").toString(), t = Cookies.get("recentlyViewed"), a = recentlyViewed.getCookieProducts(t, e)) : $(".recently-viewed__section").length ? (t = Cookies.get("recentlyViewed"), a = recentlyViewed.getCookieProducts(t, e)) : $(".js-sidebar-recently-viewed").length && (t = Cookies.get("recentlyViewed"), a = recentlyViewed.getCookieProducts(t, e)), a && (o = unescape(a).split(",")), e ? (-1 !== !$.inArray(e, o) && (i = [], o.unshift(e), $.each(o, function(e, t) {
                    -1 === $.inArray(t, i) && i.push(t)
                })), recentlyViewed.setCookieProducts(i)) : i = o, $(".recently-viewed__section").length) {
                var s = ".recently-viewed__section";
                if ($(s).data("recently-viewed-items-loaded")) return !1;
                recentlyViewed.getProductInformation(s, i, e)
            } else if ($(".js-recently-viewed .rv-main").length) {
                s = ".js-recently-viewed";
                if ($(s).data("recently-viewed-items-loaded")) return !1;
                recentlyViewed.getProductInformation(s, i, e)
            }
            if ($(".sidebar .js-sidebar-recently-viewed").length) {
                s = ".sidebar .js-sidebar-recently-viewed";
                if ($(s).data("recently-viewed-items-loaded")) return !1;
                e ? recentlyViewed.getProductInformation(s, i, e) : recentlyViewed.getProductInformation(s, i)
            }
        },
        getCookieProducts: function(e, t) {
            return !e && t ? (Cookies.set("recentlyViewed", t, {
                expires: 30,
                path: "",
                domain: "",
                sameSite: "None",
                secure: !0
            }), e = Cookies.get("recentlyViewed")) : e = Cookies.get("recentlyViewed"), e
        },
        setCookieProducts: function(e) {
            Cookies.set("recentlyViewed", escape(e.join(",")), {
                expires: 30,
                path: "",
                domain: "",
                sameSite: "None",
                secure: !0
            })
        },
        getProductInformation: function(e, t, a) {
            $(e).attr("data-recently-viewed-items-loaded", "true"), a && t.splice($.inArray(a, t), 1);
            var i = $(e).data("visible-products");
            i && t && (t = t.slice(0, i)), $.each(t, function(a, o) {
                o && ($(e).removeClass("hidden"), $(e).parents(".sidebar-block").show(), $.ajax({
                    type: "GET",
                    url: "/products/" + o + "?view=rv",
                    success: function(t) {
                        var i = $(t).find(".js-recently-viewed-product");
                        $(e).find(" .rv-box-" + a).append(i), Currency.show_multiple_currencies && currencyConverter.convertCurrencies(), Shopify.theme_settings.collection_secondary_image && imageFunctions.showSecondaryImage(), i.find("[data-html5-video] video, [data-youtube-video]").length > 0 && videoFeature.setupPlayerForRecentlyViewedProducts(i.find("[data-html5-video] video, [data-youtube-video]"))
                    },
                    error: function(e, t, a) {
                        console.log(e), console.log(t), console.log(a)
                    },
                    dataType: "html"
                })), $(e).find(".rv-main").hasClass("js-rv-slider") ? (t.length <= i ? $(".js-rv-slider .gallery-cell").eq(t.length).nextAll().addBack().remove() : $(".js-rv-slider .gallery-cell").eq(i).nextAll().addBack().remove(), recentlyViewed.createSlider(e, i)) : $(e).find(".rv-main").hasClass("js-rv-grid") && (t.length <= i ? $(".js-rv-grid .thumbnail").eq(t.length).nextAll().addBack().remove() : $(".js-rv-grid .thumbnail").eq(i).nextAll().addBack().remove())
            })
        },
        createSlider: function(e, t) {
            var a, i = $(".js-rv-slider").data("products-per-slide"),
                o = $(".js-rv-slider").find(".gallery-cell").length,
                s = $(".js-rv-slider").data("products-available"),
                r = "left",
                n = !0,
                l = !0;
            i >= o && (r = "center", n = !1, l = !1), "2" == i && s > i || "4" == i && s > i || "6" == i && s > i ? a = 0 : "3" == i && s ? a = 1 : "5" == i && s ? a = 2 : "7" == i && s && (a = 3), $(".js-rv-slider").flickity({
                lazyLoad: 2,
                imagesLoaded: !0,
                prevNextButtons: l,
                wrapAround: n,
                cellAlign: r,
                pageDots: usePageDots,
                contain: !0,
                freeScroll: !0,
                arrowShape: arrowSize,
                initialIndex: a
            }), $(".js-rv-slider").addClass("slider-initialized")
        }
    },
    enableLoadMoreButton = function(e) {
        var t = e + "[data-load-more--grid]",
            a = e + " [data-load-more--grid-item]";
        $("body").on("click", "[data-load-more]", function(e) {
            e.preventDefault();
            var i = $(this);
            ! function(e, i) {
                $.ajax({
                    type: "GET",
                    dataType: "html",
                    url: e,
                    beforeSend: function() {
                        i.addClass("is-loading"), $(".load-more__icon").addClass("loading-in-progress").css({
                            height: "40px",
                            width: "40px",
                            opacity: "1"
                        })
                    },
                    success: function(e) {
                        i.removeClass("is-loading"), $(".load-more__icon").removeClass("loading-in-progress").css({
                            height: "0",
                            width: "0",
                            opacity: "0"
                        });
                        var o = $(e).find(a),
                            s = $(e).find("[data-load-more]").attr("href");  
                        $("[data-load-more]").attr("href", s),$(t).first().append(o).append($('.totalViewProductsNumber')).append($(".js-load-more")),
                        $('.totalViewProductsNumber .currentlyViewedNumber').text($('.product-list .product-wrap').length),void 0 === s && $("[data-load-more]").addClass("is-hidden")
                      Shopify.theme_settings.enable_shopify_review_comments && Shopify.theme_settings.enable_shopify_collection_badges && SPR.$(document).ready(function() {
                        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
                    }), Currency.show_multiple_currencies && currencyConverter.convertCurrencies(), Shopify.PaymentButton && Shopify.PaymentButton.init(), productPage.init(), Shopify.theme_settings.quick_shop_enabled && quickShop.init(), hideNoScript(), videoFeature.init(), Shopify.theme_settings.collection_secondary_image && imageFunctions.showSecondaryImage(), Waypoint.refreshAll()
                      window.quickCartMainFunc && window.quickCartMainFunc()
                    },
                    error: function(e, t, a) {
                        console.log(e), console.log(t), console.log(a), location.replace(location.protocol + "//" + location.host + filterURL)
                    }
                })
            }(i.attr("href"), i)
        })
    },
    enableLoadMoreProducts = function() {
        $("body").on("click", ".js-load-more a", function(e) {
            return enableInfiniteScroll(), e.stopPropagation(), !1
        })
    },
    enableInfiniteScroll = function() {
        if ($(".collection-matrix").length) new Waypoint.Infinite({
            element: $(".collection-matrix")[0],
            items: ".collection-matrix",
            more: "[data-load-more]",
            loadingClass: "loading-in-progress",
            onBeforePageLoad: function() {
                $(".js-load-more").hide()
            },
            onAfterPageLoad: function(e) {
                $(".collection-matrix > .collection-matrix .thumbnail").unwrap(".collection-matrix"), Shopify.theme_settings.enable_shopify_review_comments && Shopify.theme_settings.enable_shopify_collection_badges && SPR.$(document).ready(function() {
                    return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
                }), Currency.show_multiple_currencies && currencyConverter.convertCurrencies(), Shopify.PaymentButton && Shopify.PaymentButton.init(), productPage.init(), Shopify.theme_settings.quick_shop_enabled && quickShop.init(), hideNoScript(), videoFeature.init(), Shopify.theme_settings.collection_secondary_image && imageFunctions.showSecondaryImage(), Waypoint.refreshAll()
            }
        })
    },
    enableLoadMoreSearch = function() {
        $("body").on("click", ".js-load-more a", function(e) {
            return enableInfiniteSearchScroll(), e.stopPropagation(), !1
        })
    },
    enableInfiniteSearchScroll = function() {
        if ($(".search-matrix").length) new Waypoint.Infinite({
            element: $(".search-matrix")[0],
            items: ".search-matrix",
            more: "[data-load-more]",
            loadingClass: "loading-in-progress",
            onBeforePageLoad: function() {
                $(".js-load-more").hide()
            },
            onAfterPageLoad: function(e) {
                $(".search-matrix > .search-matrix .thumbnail").unwrap(".search-matrix"), Shopify.theme_settings.enable_shopify_review_comments && Shopify.theme_settings.enable_shopify_collection_badges && SPR.$(document).ready(function() {
                    return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
                }), Currency.show_multiple_currencies && currencyConverter.convertCurrencies(), Shopify.PaymentButton && Shopify.PaymentButton.init(), productPage.init(), Shopify.theme_settings.quick_shop_enabled && quickShop.init(), hideNoScript(), videoFeature.init(), Shopify.theme_settings.collection_secondary_image && imageFunctions.showSecondaryImage()
            }
        })
    },
    hideNoScript = function() {
        $(".image__container .noscript").addClass("hidden")
    };
if (Shopify.queryParams = {}, location.search.length)
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&"); i < aCouples.length; i++)(aKeyValue = aCouples[i].split("=")).length > 1 && (Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]));
var quickFilter = {
        init: function() {
            var e = [],
                t = "",
                a = "",
                i = $.url("1") ? "/" + $.url("1") + "/" : "";
            if (i.length <= 4 ? (url2 = $.url("2") ? $.url("2") + "/" : "", url3 = $.url("3") ? $.url("3") + "/" : "", path = i + url2 + url3) : (url2 = $.url("2") ? $.url("2") + "/" : "", path = i + url2), t = $("#sort-by").length ? $("#sort-by").val() : url("?sort_by"), $("#tag_filter").length) {
                var o = $("#tag_filter").val();
                if ($("#tag_filter").data("default-collection") != o) {
                    urlTag = o.substr(o.lastIndexOf("/") + 1);
                    var s = o.substr(o);
                    $("#tag_filter option").removeAttr("selected"), $('#tag_filter option[value="' + s + '"]').attr("selected", "selected"), "all" != urlTag && ($.inArray(urlTag, e) > -1 || e.unshift(urlTag))
                }
            }
            $("[data-option-filter] input:checked").each(function() {
                e.push($(this).val())
            }), e = $.makeArray(e), $.each(e, function(t, i) {
                t != e.length - 1 ? a += e[t] + "+" : a += e[t]
            }), Shopify.queryParams.sort_by = t, t = "?" + $.param(Shopify.queryParams), quickFilter.processUrl(path, a, t)
        },
        updateView: function(e) {
            $.ajax({
                type: "GET",
                url: e,
                beforeSend: function() {
                    $(".collection-matrix").addClass("fadeOut animated loading-in-progress filter-loading"), Waypoint.destroyAll()
                },
                success: function(t) {
                    $(".collection-matrix").removeClass("loading-in-progress"), $(".collection-matrix").removeClass("filter-loading");
                    //Launch script 
                    const productsAssignmentScript = $(t).find("#productsAssignmentScript").html();
                    eval(productsAssignmentScript);
                    var a = $(t).find(".breadcrumb_text").html();
                    $(".breadcrumb_text").html(a);
                    var i = $(t).find(".paginate").html();
                    $(".paginate").html(i);
                    var o = $(t).find(".sidebar").html();
                    $(".sidebar").html(o);
                    var s = $(t).find(".paginate").html();
                    $(".paginate").empty(), $(".paginate").html(s);
                    var r = $(t).find(".collection-matrix");
                    $(".collection-matrix").remove(), r.insertBefore($(".load-more__icon")), window.history && window.history.pushState && window.history.pushState("", "", e), $(".sidebar__collection-filter").length && collectionSidebarFilter.init(), "infinite_scroll" == Shopify.theme_settings.pagination_type && enableInfiniteScroll(), Currency.show_multiple_currencies && currencyConverter.convertCurrencies(), Shopify.theme_settings.enable_shopify_review_comments && Shopify.theme_settings.enable_shopify_collection_badges && SPR.$(document).ready(function() {
                        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
                    }), recentlyViewed.init(), $(".js-product_section .product_form_options").each(function() {
                        new Shopify.OptionSelectors($(this).data("select-id"), {
                            product: $(this).data("product"),
                            onVariantSelected: selectCallback,
                            enableHistoryState: $(this).data("enable-state")
                        })
                    }), productPage.init(), $("body").off("click", ".swatch-element"), productPage.productSwatches(), $(".swatch_options input").each(function() {
                        $(this).is(":checked") && quickShop.toggleSwatchImages($(this))
                    }), $(".swatch_options label").on("click", function() {
                        quickShop.toggleSwatchImages($(this))
                    }), Shopify.PaymentButton && Shopify.PaymentButton.init()
                    setTimeout(()=>{
                      window.runFilters();
                    }, 500)
                },
                error: function(t, a, i) {
                    console.log(t), console.log(a), console.log(i), location.replace(location.protocol + "//" + location.host + e)
                },
                dataType: "html"
            })
        },
        processUrl: function(e, t, a) {
            var i;
            i = e + t + (a = a.replace(/\page=(\w+)&/, "")), quickFilter.updateView(i)
        }
    },
    searchAutocomplete = {
        vars: {
            term: "",
            searchPath: Shopify.routes.search_url,
            displayTimer: ""
        },
        init: function() {
            this.unload(), $("[data-autocomplete-true]").on("focus", function() {
                $(this).parents("[data-autocomplete-true]").find(".search__results-wrapper").show()
            }), $(document).on("click focusout", function(e) {
                Shopify.media_queries.large.matches && $(e.target).parents(".search__form").length
            }), $('[data-dropdown-rel="search"], [data-autocomplete-true] input').on("click touchstart", function(e) {
                if (Shopify.media_queries.medium.matches) {
                    e.preventDefault(), e.stopPropagation();
                    var t = $(this).closest("form").find('[name="type"]').val(),
                        a = $(document).scrollTop();
                    searchAutocomplete.showMobileSearch(t, a)
                }
            }), $(".search-close").on("click touchstart", function() {
                $("body").removeClass("is-active"), $(".dropdown_link").removeClass("active_link"), $(".dropdown_container").hide(), $(".mobile_nav").find("div").removeClass("open"), $("[data-autocomplete-true] .search__results-wrapper").hide().removeClass("results-found")
            }), $("[data-autocomplete-true] form").on("submit", function(e) {
                e.preventDefault();
                var t = $(this).find('input[name="q"]').val(),
                    a = encodeURI(t);
                if ($(this).find('[name="type"]').length > 0) var i = $(this).find('[name="type"]').val();
                else i = Shopify.theme_settings.search_option;
                window.location.href = null == a ? Shopify.routes.search_url + "?type=" + i : searchAutocomplete.vars.searchPath + "?type=" + i + "&q=" + a + "*"
            }), $("[data-autocomplete-true] form").each(function() {
                var e = $(this),
                    t = e.find('input[name="q"]');
                $('<div class="search__results-wrapper"><ul class="search__results"></ul></div>').appendTo(e), t.attr("autocomplete", "off").on("input", function() {
                    clearTimeout(searchAutocomplete.vars.displayTimer), $(this).val().length > 0 ? (searchAutocomplete.vars.term = $(this).val(), searchAutocomplete.getResults(searchAutocomplete.vars.term, e)) : $("[data-autocomplete-true] .search__results-wrapper").hide().removeClass("results-found")
                })
            })
        },
        getResults: function(e, t) {
            if (t.find('[name="type"]').length > 0) var a = t.find('[name="type"]').val();
            else a = Shopify.theme_settings.search_option;
            jQuery.getJSON("/search/suggest.json", {
                q: e,
                resources: {
                    type: a,
                    limit: Shopify.theme_settings.search_items_to_display,
                    options: {
                        unavailable_products: "last",
                        fields: "title,body,variants.title,vendor,product_type,tag"
                    }
                }
            }).done(function(e) {
                var a = [e.resources.results.products, e.resources.results.pages, e.resources.results.articles],
                    i = [];
                $.each(a, function(e, t) {
                    void 0 !== t && t.length > 0 && i.push(t)
                }), searchAutocomplete.vars.displayTimer = setTimeout(function() {
                    searchAutocomplete.displayResults(i[0], t)
                }, 500)
            })
        },
        displayResults: function(e, t) {
            var a = t.find(".search__results-wrapper"),
                i = t.find(".search__results");
            if (a.show(), i.empty(), t.find('[name="type"]').length > 0) var o = t.find('[name="type"]').val();
            else o = Shopify.theme_settings.search_option;
            if (e && e.length > 0) $.each(e, function(e, t) {
                var a = $('<a tabindex="0"></a>').attr("href", t.url);
                if ("/" !== Shopify.routes.root_url && (a = $('<a tabindex="0"></a>').attr("href", Shopify.routes.root_url + t.url)), t.price) {
                    function o(e) {
                        return '<span class="money">' + Shopify.formatMoney(e, $("body").data("money-format")) + "</span>"
                    }
                    if (!0 === t.available)
                        if (t.compare_at_price_max > t.price_max || t.compare_at_price_min > t.price_min) var s = o(t.price) + ' <span class="was_price">' + o(t.compare_at_price_max) + "</span>";
                        else if (t.price > 0)
                        if (t.price_min != t.price_max) s = Shopify.translation.from_text + " " + o(t.price);
                        else s = o(t.price);
                    else s = Shopify.theme_settings.free_text;
                    else s = Shopify.theme_settings.sold_out_text;
                    t.image && a.append('<div class="thumbnail"><img class="lazyload transition--' + Shopify.theme_settings.image_loading_style + '" src="' + utils.addImageDimension(t.image, "_300x") + '" /></div>'), a.append('<div class="search-title">' + t.title + '<br><span class="item-pricing price">' + s + "</span></div>")
                } else t.summary_html ? ("NULL" != t.image && a.append('<div class="thumbnail"><img class="lazyload transition--' + Shopify.theme_settings.image_loading_style + '" src="' + utils.addImageDimension(t.image, "_300x") + '" /></div>'), a.append('<div class="search-title">' + t.title + '<br><span class="item-description">' + t.summary_html.replace(/(<([^>]+)>)/gi, "").slice(0, 25) + " </span></div>")) : t.published_at && a.append('<div class="search-title">' + t.title + '<br><span class="item-description">' + t.body.replace(/(<([^>]+)>)/gi, "").slice(0, 25) + " </span></div>");
                a.wrap('<li class="item-result"></li>'), i.append(a.parent())
            }), i.prepend('<li class="all-results"><span class="search-title see-all"><a href="' + this.vars.searchPath + "?type=" + o + "&q=" + this.vars.term + '*"><span>' + Shopify.translation.all_results + '</span><span class="icon-right-arrow"></span></a></span></li>'), (Currency.show_multiple_currencies || Currency.native_multi_currency) && currencyConverter.init(), i.parents(".search__results-wrapper").addClass("results-found");
            else {
                var s = '<li class="item-result"><span class="no-results search-title">' + Shopify.translation.no_results + "</span></li>";
                i.append(s), i.parents(".search__results-wrapper").removeClass("results-found")
            }
            i.show()
        },
        showMobileSearch: function(e, t) {
            $("body").css("max-height", window.innerHeight), $(".mobile-search").fadeIn(200), /iPad|iPhone|iPod/.test(navigator.platform) || "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1 ? $(".mobile-search input#q").focus() : setTimeout(function() {
                $(".mobile-search input#q").focus()
            }, 205), document.body.style.position = "fixed", document.body.style.top = "-" + t + "px", $(".mobile-search").css("top", t);
            var a = window.innerHeight - 60;
            $(".mobile-search .search__results-wrapper").css("max-height", a), e ? $('.mobile-search [name="type"]').val(e) : $('.mobile-search [name="type"]').val(Shopify.theme_settings.search_option), $(".search-form .close-search").on("click touchstart", function(e) {
                e.preventDefault(), e.stopPropagation(), searchAutocomplete.hideMobileSearch(t), $("[data-autocomplete-true] .search__results-wrapper").hide().removeClass("results-found")
            }), $(".search-form .submit-search").on("click touchstart", function(e) {
                $(this).parents("form").submit()
            })
        },
        hideMobileSearch: function(e) {
            $("body").css("max-height", "none"), document.body.style.position = "", document.body.style.top = "", window.scrollTo(0, e), $(".mobile-search").fadeOut(200), $('.mobile-search [name="q"]').val(""), $("body").off("focus", ".search-form .close-search"), $("body").off("focus", ".search-form .submit-search")
        },
        unload: function() {
            $("body").off("focus", "[data-autocomplete-true] input"), $('input[name="q"]').off(), $('[data-dropdown-rel="search"], [data-autocomplete-true] input').off(), $(".search__results-wrapper").remove()
        }
    },
    collectionSidebarFilter = {
        init: function() {
            $(".filter-active-tag input:checked").parents(".filter-active-tag").siblings(".filter-all-tags").hide(), $(".toggle-all--true .toggle_list .filter-active-tag input:checked").parents("ul.toggle_list").prev().click(), window.location.search.indexOf("sort_by") > 0 && $(".toggle-all--true .toggle_list .filter-active-tag input").attr("checked") && $(".sidebar__collection-filter > h4").addClass("active"), "types" !== $.url(2) && "vendors" !== $.url(2) || $(".sidebar__collection-filter").remove(), $(".sidebar-block:empty").prev().css("border-bottom", "none"), recentlyViewed.init()
        },
        clearAllFilters: function() {
            $("[data-option-filter] input").prop("checked", !1), $("[data-option-filter] input").trigger("change"), recentlyViewed.init()
        },
        clearSelectedFilter: function(e) {
            $("#tag_filter").length && e.find("[data-option-filter] input").val() === $("#tag_filter option:selected ").val().substr($("#tag_filter option:selected ").val().lastIndexOf("/") + 1) && $("#tag_filter").val($("#tag_filter option:first").val()), e.find("[data-option-filter] input").prop("checked", !1), e.find("[data-option-filter] input").trigger("change"), recentlyViewed.init()
        }
    };
if ("bold" == Shopify.theme_settings.slideshow_arrow_size) var arrowSize = {
        x0: 10,
        x1: 40,
        y1: 50,
        x2: 80,
        y2: 50,
        x3: 50
    },
    svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 40,100 L 80,100 L 50,50  L 80,0 L 40,0 Z" class="arrow"></path></svg>',
    svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 40,100 L 80,100 L 50,50  L 80,0 L 40,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>';
else if ("light" == Shopify.theme_settings.slideshow_arrow_size) arrowSize = {
    x0: 10,
    x1: 60,
    y1: 50,
    x2: 62,
    y2: 40,
    x3: 22
}, svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg>', svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>';
else if ("regular" == Shopify.theme_settings.slideshow_arrow_size) arrowSize = {
    x0: 10,
    x1: 60,
    y1: 50,
    x2: 70,
    y2: 40,
    x3: 30
}, svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>', svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>';

function isScreenSizeLarge() {
    if (window.matchMedia("(min-width: 1024px)").matches) return !0
}
var globalQuickShopProduct, videosInRecommendedProductsPlayer, utils = {
        createAccordion: function(e, t, a) {
            var i = $(e),
                o = $(e).find(t),
                s = $(e).find(a),
                r = e + " " + t;
            if (e.indexOf(".accordion-tabs") >= 0) {
                var n = $.map(o, function(e, t) {
                    return [e, s[t]]
                });
                i.empty(), $.each(n, function(e, t) {
                    i.append(this)
                }), s.removeClass("active"), i.find(".active").next().slideToggle(), t = e + "> a"
            }
            $(e).children("a").each(function(e, t) {
                var a = (t = $(this)).attr("href");
                t.attr("data-tab-value", a), t.removeAttr("href")
            }), $(e).find(t + ".active").next().slideToggle(), $("body").on("click", r, function(e) {
                e.preventDefault(), $(this).toggleClass("active"), $(this).next().slideToggle()
            })
        },
        mobileAccordion: function(e, t, a) {
            $container = $(e), $tab = $(e).find(t), $content = $(e).find(a), $(t + ".active").next().slideToggle(), $("body").on("click", t, function(e) {
                e.preventDefault(), $(this).toggleClass("active"), $(this).next().slideToggle()
            })
        },
        mobileParentActiveAccordion: function(e, t, a) {
            $container = $(e), $tab = $(e).find(t), $content = $(e).find(a), $(t + ".active").parent().next().slideToggle(), $("body").on("click", t, function(e) {
                e.preventDefault(), $(this).toggleClass("active"), $(this).parent().next().slideToggle()
            })
        },
        initializeTabs: function() {
            $("ul.tabs > li > a").attr("data-no-instant", !0), $("body").on("click", "ul.tabs > li > a", function(e) {
                e.preventDefault();
                var t = $(this).attr("href");
                "#" == t.charAt(0) && ($("ul.tabs > li > a.active").removeClass("active"), $(this).addClass("active"), $(this).parents("ul.tabs").next().find(t).show().css({
                    display: "block"
                }).addClass("active").siblings().hide().removeClass("active"))
            })
        },
        productReviewScroll: function() {
            $("#shopify-product-reviews").length && $(".shopify-product-reviews-badge").length && $(".spr-badge-container").on("click", function() {
                utils.scrollToTop("#shopify-product-reviews")
            })
        },
        scrollToTop: function(e, t) {
            null != t ? $("html, body").animate({
                scrollTop: $(e).offset().top - t
            }, 1e3) : $("html, body").animate({
                scrollTop: $(e).offset().top
            }, 1e3)
        },
        pageBannerCheck: function() {
            !$(".page-banner").length > 0 || $(".header").hasClass("header-background--solid") ? ($(".feature_image").removeClass("feature_image"), $(".header.is-absolute").removeClass("is-absolute"), $(".secondary_logo--true").find(".secondary_logo").css("display", "none"), $(".secondary_logo--true").find(".primary_logo").css("display", "block")) : $(".page-banner").hasClass("full-width--true") ? ($(".header").parent().addClass("feature_image"), $(".header").addClass("is-absolute"), $("header.feature_image").hasClass("secondary_logo--true") && ($(".secondary_logo--true").find(".secondary_logo").css("display", "block"), $(".secondary_logo--true").find(".primary_logo").css("display", "none"))) : ($(".header").parent().removeClass("feature_image"), $(".header").removeClass("is-absolute")), $(".index-sections").children().first(".under-menu").find(".full-width--true").length ? ($(".header").hasClass("header-background--solid") || ($(".index .header").parent().addClass("feature_image"), $(".index .header").addClass("is-absolute")), $("header.feature_image").hasClass("secondary_logo--true") && ($(".secondary_logo--true").find(".secondary_logo").show(), $(".secondary_logo--true").find(".primary_logo").hide())) : ($(".index .feature_image").removeClass("feature_image"), $(".index .header.is-absolute").removeClass("is-absolute"), $("header.feature_image").hasClass("secondary_logo--true") || ($(".secondary_logo--true").find(".secondary_logo").hide(), $(".secondary_logo--true").find(".primary_logo").show())), $(".detail-sections").children().first().hasClass("under-menu") ? ($(".header").hasClass("header-background--solid") || ($('[class^="page-details"] .header').parent().addClass("feature_image"), $('[class^="page-details"] .header').addClass("is-absolute")), $("header.feature_image").hasClass("secondary_logo--true") && ($(".secondary_logo--true").find(".secondary_logo").show(), $(".secondary_logo--true").find(".primary_logo").hide())) : ($('[class^="page-details"] .feature_image').removeClass("feature_image"), $('[class^="page-details"] .header.is-absolute').removeClass("is-absolute"), $("header.feature_image").hasClass("secondary_logo--true") || ($(".secondary_logo--true").find(".secondary_logo").hide(), $(".secondary_logo--true").find(".primary_logo").show()))
        },
        enableDisclosure: function() {
            var e = $("[data-disclosure]"),
                t = $("[data-disclosure-toggle]"),
                a = $(".disclosure__list-wrap");

            function i(e) {
                e.siblings(".disclosure__list-wrap").is(":off-right") && e.siblings(".disclosure__list-wrap").addClass("disclosure--left")
            }

            function o(e, i) {
                !0 === e ? (t.not(i).removeClass("is-clicked"), t.not(i).attr("aria-expanded", "false")) : (t.removeClass("is-clicked"), t.attr("aria-expanded", "false")), a.removeClass("disclosure--left")
            }
            $("body").on("keyup", function(e) {
                "27" == e.which && o()
            }), e.on("mouseleave", function(e) {
                o()
            }), t.on("mouseenter focus", function(e) {
                o(!0, this);
                var t = $(e.currentTarget);
                t.attr("aria-expanded", "true").addClass("is-clicked"), i(t)
            }), $(".disclosure__button").on("focusout", function(e) {
                $(e.relatedTarget).hasClass("disclosure__button") && !$(e.relatedTarget).hasClass("disclosure__toggle") || o()
            }), t.on("touchstart", function(e) {
                if (Shopify.media_queries.medium.matches || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    var t = $(e.currentTarget);
                    o(!0, this), t.hasClass("is-clicked") ? (t.attr("aria-expanded", "false").removeClass("is-clicked"), a.removeClass("disclosure--left")) : (t.attr("aria-expanded", "true").addClass("is-clicked"), i(t))
                }
            })
        },
        addImageDimension: function(e, t) {
            var a = e.lastIndexOf(".");
            return e.substring(0, a) + t + e.substring(a)
        },
        unload: function(e) {
            $("[data-disclosure]").off(), $("[data-disclosure-toggle]").off()
        }
    },
    sliderBlock = {
        select: function(e, t) {
            var a = t.find(".gallery-cell").map(function() {
                    return String($(this).data("block-id"))
                }),
                i = t.find("[data-slider-id]"),
                o = (i.data("slideshow-text-animation"), i.data("flickity"));
            i.flickity("pausePlayer");
            for (var s = 0; s < a.length; s++)
                if (a[s] === e) {
                    var r = s;
                    r !== o.selectedIndex && i.flickity("select", parseInt(r), !1, !0)
                }
        },
        deselect: function(e) {
            var t = e.find(".flexslider").data("flexslider");
            t && t.flickity("unpausePlayer")
        }
    },
    quickShop = {
        init: function() {
            $("body").on("click", ".js-quick-shop-link", function(e) {
                e.stopImmediatePropagation(), e.preventDefault();
                var t = {
                        handle: $(this).data("handle"),
                        product_id: $(this).data("id"),
                        single_variant: $(this).attr("data-single-variant"),
                        product_in_collection_url: $(this).data("url"),
                        escaped_title: $(this).data("title").replace('"', ""),
                        escaped_vendor: $(this).data("vendor").replace(/\&/g, "%26"),
                        details_text: $(this).data("details-text"),
                        full_description: $(this).data("full-description"),
                        regular_description: $(this).data("regular-description"),
                        feat_img: $(this).data("feat-img"),
                        image_array: quickShop.createImageObjects($(this).data("images")),
                        thumbnail_array: quickShop.createImageObjects($(this).data("thumbnail-images")),
                        collection_handles: $(this).data("collection-handles").trim(",").split(","),
                        money_format: $("body").data("money-format")
                    },
                    a = $(this).next(".js-quickshop-forms__container").find(".notify_form"),
                    i = $(this).next(".js-quickshop-forms__container").find(".product_form");
                $.fancybox.open($(".js-quick-shop"), {
                    baseClass: "quick-shop__lightbox product-" + t.product_id,
                    hash: !1,
                    infobar: !1,
                    toolbar: !1,
                    loop: !1,
                    smallBtn: !0,
                    video: {
                        autoStart: !1
                    },
                    touch: !1,
                    mobile: {
                        preventCaptionOverlap: !1,
                        toolbar: !0,
                        buttons: ["close"]
                    },
                    beforeLoad: function() {
                        quickShop.beforeOpen(t)
                    },
                    afterLoad: function() {
                        quickShop.afterContent(i, a, t), videoFeature.setupRecommendedVideoPlayer(), productMedia.setupMedia()
                    },
                    afterShow: function() {},
                    beforeClose: function() {
                        quickShop.beforeClose(t)
                    }
                })
            }), $(".swatch_options input").each(function() {
                $(this).is(":checked") && quickShop.toggleSwatchImages($(this))
            }), $(".swatch_options label").on("click", function() {
                quickShop.toggleSwatchImages($(this))
            })
        },
        toggleSwatchImages: function(e) {
            var t = $(e).data("image"),
                a = $(e).parents(".thumbnail").find(".image__container img");
            a.attr("src", t), a.attr("srcset", t)
        },
        createImageObjects: function(e) {
            return e.split("~").map(function(e) {
                var t = e.split("^");
                return {
                    path: t[0],
                    alt: t[1],
                    id: t[2],
                    mediaType: t[4]
                }
            })
        },
        beforeOpen: function(e) {
            quickShop.populateGallery(e), $(".js-sale-banner, .js-sold-out, .js-current-price, .js-was-price, .js-savings, .js-new-banner, .js-pre-order-banner").empty(), $(".modal_price, .js-notify-form").show(), e.image_array.length > 1 ? ($(".js-gallery-modal").addClass("multi-image"), $(".js-gallery-modal").removeClass("single-image"), $(".js-gallery-modal").addClass("is-draggable")) : ($(".js-gallery-modal").addClass("single-image"), $(".js-gallery-modal").removeClass("multi-image"))
        },
        afterContent: function(e, t, a) {
            quickShop.retrieveProductInfo(a), videoFeature.setupVideoPlayer();
            var i = $(".js-gallery-modal");
            if (productPage.enableGallery(i), $(".js-quickshop-forms--" + a.product_id).empty(), e.appendTo(".quick-shop__lightbox .js-product-form"), t.appendTo(".quick-shop__lightbox .js-product-form"), e.hasClass("product_form_options") && 0 == e.hasClass("viewed") ? new Shopify.OptionSelectors(e.data("select-id"), {
                    product: e.data("product"),
                    onVariantSelected: selectCallback,
                    enableHistoryState: e.data("enable-state")
                }) : Currency.show_multiple_currencies && currencyConverter.convertCurrencies(), "swatches" == Shopify.theme_settings.product_form_style) {
                var o = e.data("product"),
                    s = ".product-" + a.section_id + " .js-product_section";
                e.find(".swatch_options .swatch").length > 1 && Shopify.linkOptionSelectors(o, s)
            }
            $('.js-quick-shop select[name="id"]').trigger("change"), utils.initializeTabs(), productPage.productSwatches()
        },
        beforeClose: function(e) {
            var t = $(".quick-shop__lightbox .notify_form"),
                a = $(".quick-shop__lightbox .product_form");
            $(".js-quickshop-forms--" + e.product_id).append(a), $(".js-quickshop-forms--" + e.product_id).append(t), $(".js-quickshop-forms--" + e.product_id + " .product_form").addClass("viewed"), $(".js-quickshop-forms--" + e.product_id + " .notify_form").addClass("viewed");
            var i = $(".js-gallery-modal"),
                o = $(".js-gallery-carousel");
            $(".js-gallery-carousel .gallery-cell").off("click"), i.flickity("remove", $(".gallery-cell", i)), i.flickity("destroy"), o.hasClass("flickity-enabled") ? (o.flickity("remove", $(".gallery-cell", o)), o.flickity("destroy")) : o.find(".gallery-cell").remove();
            var s = $(".js-current-price .money").text();
            $(".js-quick-shop-link[data-id=" + e.product_id + "]").attr("data-initial-modal-price", s), $(".js-current-price, .js-was-price, .js-savings").empty()
        },
        retrieveProductInfo: function(e) {
            $.ajax({
                dataType: "json",
                async: !1,
                cache: !1,
                url: "/products/" + e.handle + ".js",
                success: function(t) {
                    t = $.extend({}, t, e), globalQuickShopProduct = t, quickShop.updateVariant(t.variants[0].id.toString(), t)
                }
            })
        },
        updateVariant: function(e) {
            if ("undefined" != globalQuickShopProduct) {
                var t = globalQuickShopProduct;
                $(".js-current-price").html(""), $(".js-was-price").html(""), $(".js-savings").html(""), $(".js-product-title").html('<a href="' + t.product_in_collection_url + '" title="' + t.escaped_title + '">' + t.title + "</a>"), $(".js-product-vendor").html('<a href="/collections/vendors?q=' + t.escaped_vendor + '">' + t.vendor + "</a>"), $(".js-full-description").html(t.full_description), $(".js-regular-description").html(t.regular_description);
                var a = '<a href="' + t.product_in_collection_url + '" class="secondary_button" title="' + t.escaped_title + ' Details">' + t.details_text + "</a>";
                if ($(".js-product-details").html(a), $.each(t.collection_handles, function(e, a) {
                        "new" == this.toString() && $(".js-new-banner").html(Shopify.translation.new_text), "pre-order" == this.toString() && $(".js-pre-order-banner").html(Shopify.translation.pre_order_text), "coming-soon" == this.toString() && (t.price = Shopify.translation.coming_soon_text)
                    }), "true" == t.single_variant) Shopify.theme_settings.sale_banner_enabled && t.compare_at_price > t.price && $(".js-sale-banner").html(Shopify.translation.sale_text), t.compare_at_price > t.price ? $(".js-current-price").addClass("sale") : $(".js-current-price").removeClass("sale"), 0 == t.available ? t.price == Shopify.translation.coming_soon_text ? $(".js-sold-out").html(Shopify.translation.coming_soon_text) : $(".js-sold-out").html(Shopify.theme_settings.sold_out_text) : $(".js-sold-out").html(""), (1 == t.available || 0 == t.available && Shopify.theme_settings.display_sold_out_price) && (t.compare_at_price > t.price && ($(".js-was-price").html('<span class="money">' + Shopify.formatMoney(t.variants[0].compare_at_price, t.money_format) + "</span>"), $(".js-savings").html(Shopify.translation.savings_text + " " + parseInt(100 * (t.variants[0].compare_at_price - t.variants[0].price) / t.variants[0].compare_at_price) + '% ( <span class="money">' + Shopify.formatMoney(t.variants[0].compare_at_price - t.variants[0].price, t.money_format) + "</span>)")), t.price == Shopify.translation.coming_soon_text ? $(".js-current-price").html(Shopify.translation.coming_soon_text) : t.price ? $(".js-current-price").html('<span class="money">' + Shopify.formatMoney(t.variants[0].price, t.money_format) + "</span>") : $(".js-current-price").html(Shopify.theme_settings.free_text)), 1 == t.available ? $(".js-notify-form").hide() : $(".js-notify-form").show();
                else
                    for (var i = 0; i < t.variants.length; i++) e == t.variants[i].id.toString() && (Shopify.theme_settings.sale_banner_enabled && t.variants[i].compare_at_price > t.variants[i].price && $(".js-sale-banner").html(Shopify.translation.sale_text), t.variants[i].compare_at_price > t.variants[i].price ? $(".js-current-price").addClass("sale") : $(".js-current-price").removeClass("sale"), 0 == t.variants[i].available ? t.price == Shopify.translation.coming_soon_text ? $(".js-sold-out").html(Shopify.translation.coming_soon_text) : $(".js-current-price").parents(".modal_price").hasClass("variant-unavailable") ? $(".js-sold-out").html(Shopify.translation.unavailable_text) : $(".js-sold-out").html(Shopify.theme_settings.sold_out_text) : $(".js-sold-out").html(""), $(".js-current-price").parents(".modal_price").hasClass("variant-unavailable") && $(".js-sold-out").html(Shopify.translation.unavailable_text), 1 == t.variants[i].available ? $(".js-notify-form").hide() : $(".js-notify-form").show(), (1 == t.variants[i].available || 0 == t.variants[i].available && Shopify.theme_settings.display_sold_out_price) && (t.variants[i].compare_at_price > t.variants[i].price && ($(".js-was-price").html('<span class="money">' + Shopify.formatMoney(t.variants[i].compare_at_price, t.money_format) + "</span>"), $(".js-savings").html(Shopify.translation.savings_text + " " + parseInt(100 * (t.variants[i].compare_at_price - t.variants[i].price) / t.variants[i].compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(t.variants[i].compare_at_price - t.variants[i].price, t.money_format) + "</span>)")), t.price == Shopify.translation.coming_soon_text ? $(".js-current-price").html(Shopify.translation.coming_soon_text) : t.variants[i].price ? $(".js-current-price").html('<span class="money">' + Shopify.formatMoney(t.variants[i].price, t.money_format) + "</span>") : $(".js-current-price").html(Shopify.theme_settings.free_text)))
            }
            Currency.show_multiple_currencies && currencyConverter.convertCurrencies()
        },
        populateGallery: function(e) {
            var t = $(".js-gallery-modal"),
                a = $(".js-gallery-carousel");
            $.each(e.image_array, function(t, a) {
                if ("" == a.path || null == a.id) var i = e.feat_img;
                else i = a.path;
                var o;
                null == a.alt || "" == a.alt || a.alt, i.replace(/(\.[^.]*)$/, "_2048x2048$1").replace("http:", ""), o = !a.mediaType || a.mediaType.indexOf("image") >= 0 ? '<div class="image__container"><img class="lazyload ' + Shopify.theme_settings.image_loading_style + '" src="' + i + '" alt="${alt}" data-zoom-src="' + i + '" data-image-id="' + a.id + '" data-index="' + t + '" /></div>' : unescape(i);
                var s = $('<div class="gallery-cell">' + o + "</div>");
                $(".js-gallery-modal").append(s)
            }), t.find(".gallery-cell").length > 1 && ($.each(e.thumbnail_array, function(e, t) {
                if ("" != t.path) {
                    var i = t.path.replace(/(\.[^.]*)$/, "_grande$1").replace("http:", ""),
                        o = "";
                    t.alt.indexOf("model") >= 0 ? o = '<span class="icon media-badge"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25H25V1H1V25Z" fill=""/><path class="media-badge__outline" d="M0.5 25V25.5H1H25H25.5V25V1V0.5H25H1H0.5V1V25Z" stroke="" stroke-opacity="0.05"/><g opacity="0.6"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 6L19.0622 9.5V16.5L13 20L6.93782 16.5V9.5L13 6Z" stroke="" stroke-width="1.5"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13 20V12.6024C13.6225 12.2002 13.6225 12.2002 13.6225 12.2002L19 9V16.4082L13 20Z" fill=""/></g></svg></span>' : (t.alt.indexOf("external_video") >= 0 || t.alt.indexOf("video") >= 0) && (o = '<span class="icon media-badge"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25H25V1H1V25Z" fill=""/><path class="media-badge__outline" d="M0.5 25V25.5H1H25H25.5V25V1V0.5H25H1H0.5V1V25Z" stroke="" stroke-opacity="0.05"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.19995 5.8V20.2L19.3999 12.5858L8.19995 5.8Z" fill="" fill-opacity="0.6"/></svg></span>');
                    var s = '<img src="' + i + '" alt="' + escape(t.alt) + '" />',
                        r = $('<div class="gallery-cell product-gallery__thumbnail">' + s + o + "</div>");
                    a.append(r)
                }
            }), imageFunctions.linkGalleryAndCarousel(t, a))
        }
    },
    newsletter_popup = {
        init: function() {
            var e = Cookies.get("popup"),
                t = parseInt(Shopify.theme_settings.newsletter_popup_days),
                a = 0 != t;
            if (a && "open" == e) return !1;
            newsletter_popup.open(), a && Cookies.set("popup", "open", {
                expires: t,
                path: "",
                domain: "",
                sameSite: "None",
                secure: !0
            })
        },
        open: function() {
            var e = parseInt(Shopify.theme_settings.newsletter_popup_seconds);
            (Shopify.theme_settings.newsletter_popup_mobile || Shopify.media_queries.large.matches) && setTimeout(function() {
                $.fancybox.open($(".js-newsletter-popup"), {
                    baseClass: "newsletter__lightbox",
                    hash: !1,
                    infobar: !1,
                    toolbar: !1,
                    loop: !0,
                    smallBtn: !0,
                    mobile: {
                        preventCaptionOverlap: !1,
                        toolbar: !0,
                        buttons: ["close"]
                    }
                })
            }, 1e3 * e)
        }
    },
    productMedia = {
        models: [],
        setupMedia: function() {
            var e = {
                controls: ["zoom-in", "zoom-out", "fullscreen"],
                focusOnPlay: !1
            };
            $($("model-viewer", $(".js-product-gallery, .js-gallery-modal"))).each(function(t, a) {
                a = new Shopify.ModelViewerUI(a, e), productMedia.models.push(a)
            }), $(".product-gallery__model model-viewer").on("mousedown", function() {
                productMedia.hideModelIcon(this)
            })
        },
        showModelIcon: function(e) {
            $(e).find(".button--poster, .model-icon-button-control").show()
        },
        hideModelIcon: function(e) {
            $(e).find(".button--poster, .model-icon-button-control").hide()
        }
    },
    videoEl = {
        playButtonIcon: '<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
        playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
        muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
        progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
        volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
        fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
    },
    videoControls = videoEl.playButtonIcon + '<div class="plyr__controls">' + videoEl.playButton + videoEl.progressInput + videoEl.muteButton + videoEl.volume + videoEl.fullscreen + "</div>",
    globalVideoPlayers = [],
    videoPlayers = [];
videoFeature = {
    init: function() {
        this.setupVideoPlayer(), this.setupRecommendedVideoPlayer()
    },
    setupVideoPlayer: function() {
        var e = document.querySelectorAll("[data-html5-video] video, [data-youtube-video]"),
            t = Plyr.setup(e, {
                controls: videoControls,
                ratio: this.aspect_ratio,
                fullscreen: {
                    enabled: !0,
                    fallback: !0,
                    iosNative: !0
                },
                storage: {
                    enabled: !1
                }
            });
        globalVideoPlayers && $.each(t, function(e, t) {
            globalVideoPlayers.push(t)
        });
        var a = $("[data-video-loop]").data("video-loop") || !1;
        $.each(t, function(e, t) {
            t.loop = a, videoPlayers.push(t)
        }), this.setupListeners()
    },
    setupPlayerForRecentlyViewedProducts: function(e) {
        if (e) {
            var t = new Plyr(e, {
                controls: videoControls,
                ratio: this.aspect_ratio,
                fullscreen: {
                    enabled: !0,
                    fallback: !0,
                    iosNative: !0
                },
                storage: {
                    enabled: !1
                }
            });
            null !== videoPlayers && (videoPlayers.push(t), this.setupListeners())
        }
    },
    setupRecommendedVideoPlayer: function() {
        var e = document.querySelectorAll(".product-recommendations [data-html5-video] video, .product-recommendations [data-youtube-video]");
        if (e.length > 0)
            if (videosInRecommendedProductsPlayer = Plyr.setup(e, {
                    controls: videoControls,
                    fullscreen: {
                        enabled: !0,
                        fallback: !0,
                        iosNative: !0
                    },
                    storage: {
                        enabled: !1
                    }
                }), null !== videoPlayers) {
                var t = videoPlayers.concat(videosInRecommendedProductsPlayer);
                videoPlayers = t
            } else videoPlayers = videosInRecommendedProductsPlayer;
        this.setupListeners()
    },
    setupListeners: function() {
        $.each(videoPlayers, function(e, t) {
            var a = t.id || t.media.dataset.plyrVideoId;
            t.isHTML5 && $(t.elements.wrapper).find("video").attr("data-plyr-video-id", a)
        }), $.each(globalVideoPlayers, function(e, t) {
            t.on("play", function(e) {
                var t = e.detail.plyr;
                $.each(globalVideoPlayers, function(e, a) {
                    t.id != a.id && a.pause()
                })
            })
        })
    },
    enableVideoOnHover: function(e) {
        var t, a = e.find("[data-html5-video]"),
            i = e.find("[data-youtube-video]");
        a.length > 0 ? t = a.find("[data-plyr-video-id]").data("plyr-video-id") : i.length > 0 && (t = i.find("iframe").attr("id")), t && $.each(videoPlayers, function(e, a) {
            a.id != t && a.media.id != t || (a.toggleControls(!1), a.muted = !0, a.play())
        })
    },
    disableVideoOnHover: function(e) {
        var t, a = e.find("[data-html5-video]"),
            i = e.find("[data-youtube-video]");
        a.length > 0 ? t = a.find("[data-plyr-video-id]").data("plyr-video-id") : i.length > 0 && (t = i.find("iframe").attr("id")), t && $.each(videoPlayers, function(e, a) {
            a.id != t && a.media.id != t || a.playing && a.pause()
        })
    }
};